export default __webpack_public_path__ + "static/media/python.e43bc37d.svg";